import {
  ActionIcon,
  Alert,
  Anchor,
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  Modal,
  ScrollArea,
  Skeleton,
  Stack,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import {
  IconArrowUpRight
} from "@tabler/icons-react";
import { logger } from "utils/logger";
import { createStyles } from "@mantine/emotion";
import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";
import { setGlobalSearch } from "app/appSlice";
import { closeAllModals } from "@mantine/modals";
import Moment from "react-moment";

// import StyleAssetViewer from "../style/StyleAssetViewer";
import {
  AppConstants, getCompanyTableColumns
} from "utils/constants";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import { getClientLabel, getImageFile, getStatusColor } from "utils/helper";
import ResolverImage from "../resolverImage/ResolverImage";
import ImagePreview from "../imagePreview/ImagePreview";
import { EmptyState } from "../emptyState/EmptyState";
import { Link } from "react-router-dom";
// import StyleAssetViewer from "modules/Distributions/features/style/StyleAssetViewer";
import { MetaLabel } from "../metaLabel/MetaLabel";
import StyleInfoSections from "../styleInfoSections/StyleInfoSections";
import StyleAssetViewer from "../styleInfoPanel/StyleAssetViewer";
import DateDisplay from "../dateDisplay/DateDisplay";

const useStyles = createStyles((theme, _, u) => ({
  container: {
    padding: 0,
    height: "100%",
    borderLeftWidth: 0,
    borderLeftStyle: "solid",
    // paddingTop: 26,
    borderColor: theme.colors.dark[4],
    [u.light]: {
      borderColor: theme.colors.gray[3],
    },
    ".mantine-Accordion-content": {
      paddingBottom: 0,
    },
    ".mantine-Accordion-control": {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderColor: theme.colors.dark[4],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    // Removed global Stack gap override - use gap prop on individual Stack components instead
    ".capture-selected > div > div:first-of-type": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    ".info-panel": {
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
  },
  badgeIndex: {
    position: "absolute",
    left: 0,
    top: 0,
  },
  imageGradient: {
    background: `linear-gradient(to top, #2e2e2e, transparent)`,
    height: 200,
    width: "100%",
    position: "absolute",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
    [u.light]: {
      background: `linear-gradient(to top, #fff, transparent)`,
    },
  },
  barcodeSection: {
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white,
  },
}));

const MasterDrawer = ({ item, opened, doFetch = true, globalSearch, user }) => {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("info");
  const [session, setSelectedSession] = useState(null);
  const [talent, setTalent] = useState([]);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const imageModalOpen = globalSearch?.imageModalOpen ?? false;
  const [scanImage, setScanImage] = useState(null);
  const selectedItem = globalSearch?.style;
  const [loading, setLoading] = useState(false);
  logger.log(globalSearch);

  const showMetaInfo = globalSearch?.showMetaInfo ?? true;

  const toggleShowMetaInfo = () => {
    dispatch(setGlobalSearch({ ...globalSearch, showMetaInfo: !showMetaInfo }));
  };

  useEffect(() => {
    logger.log(selectedItem);

    if (selectedItem && selectedItem.scanUrl) {
      getImageFile(selectedItem.scanUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          logger.log(blob);
          setScanImage({ name: item.id, preview: url });
        });
    }

    const getStyleInfo = async (id) => {
      try {
        setLoading(true);
        const data = await getStyle(id);
        logger.log(data);
        if (data && data.id && data.id.length) {
          logger.log(data);
          const { masters, sessions, seasons, assets, ...rest } = data;

          dispatch(
            setGlobalSearch({
              ...globalSearch,
              style: { ...data, masters, sessions, seasons, assets },
            })
          );
          setLoading(false);
        }else if(data && data.masters && data.masters.length){
          dispatch(setGlobalSearch({ ...globalSearch, style: {...item, masters: data.masters} }));
          setLoading(false);
        }else{
          throw new Error("Style not found");
        }
      } catch (e) {
        setLoading(false);
       
        dispatch(setGlobalSearch({ ...globalSearch, style: {...item, masters:[]} }));
        // dispatch(
        //   setError({
        //     type: ERROR_TYPES.NOT_FOUND,
        //     message: ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND],
        //   })
        // );
      }
    };
    // if (selectedItem && selectedItem.styleNumber) {
    //   if (
    //     doFetch &&
    //     (!selectedItem.assets ||
    //       (selectedItem.assets.length === 0 && !hasFetched.current && opened))
    //   ) {
    //     getStyleInfo(selectedItem.styleNumber);
    //     hasFetched.current = true;
    //   } else if (doFetch && !opened) {
    //     hasFetched.current = true;
    //   }
    // }

    // if the item is different from the global search style, then fetch the style
    if (
      item &&
      item.styleNumber &&
      item.styleNumber !== globalSearch?.style?.styleNumber
    ) {
      getStyleInfo(item.styleNumber);
    }
  }, [item, opened, globalSearch?.style]);

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedAsset(data);
    dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: true }));
  };

  const columns = user?.clientCode?getCompanyTableColumns(user.clientCode, "masters"):[];

  logger.log("item", item, columns, selectedItem);

  return (
    <Box className={`${classes.container} info-panel`}>
      <div style={{ width: "100%", height: "calc(100% - 70px)" }}>
        <ScrollArea style={{ height: "100%" }}>
          {globalSearch?.style ? (
            <Card pt="sm" style={{ background: "none" }} radius={0}>
              <Card.Section style={{ position: "relative", minHeight: loading ? 300 : 0 }}>
                {/* <Image src={src} alt={''} height={size} /> */}

                {(selectedItem?.assets && selectedItem?.assets.length && !loading) ? (
                  <ResolverImage
                    className={classes.image}
                    fit="cover"
                    src={(selectedItem?.assets && selectedItem?.assets.length && !loading) ? selectedItem?.assets[0]?.preview : ""}
                    alt={selectedItem?.name}
                    height={300}
                  />
                ) : <>{loading?<Skeleton height={300} width="100%" /> : null}</>}

                {/* {selectedItem &&
                    selectedItem.assets &&
                    selectedItem.assets.length ? (
                      <AnimatePresence mode="wait">
                        <motion.img
                          key={currentIndex}
                          src={selectedItem?.assets[currentIndex].preview}
                          alt={`Slide ${currentIndex}`}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 1 }}
                          transition={{ duration: 5 }}
                          style={{
                            width: "100%",
                            height: 300,
                            objectFit: "cover",
                            position: "relative",
                          }}
                        />
                      </AnimatePresence>
                    ) : null} */}
                {selectedItem?.assets && selectedItem?.assets.length ? (
                  <div className={classes.imageGradient}></div>
                ) : null}
              </Card.Section>

              {selectedItem?.assets && selectedItem?.assets.length ? (
                <>
                  <Link
                    className="router-link unstyled"
                    to={`/distributions/${selectedItem.styleNumber}`}
                    onClick={() => closeAllModals()}
                  >
                    <Group
                      wrap={false}
                      justify="space-between"
                      mt="lg"
                      align="flex-start"
                    >
                      {loading ? (
                        <Stack gap={"xs"}>
                          <Skeleton height={48} width={250} />
                          {/* <Skeleton height={18} width={120} /> */}
                        </Stack>
                      ) : (
                        <Title
                          className="main-content-heading"
                          order={5}
                          w={250}
                          display={"inline-block"}
                          textWrap={true}
                        >
                          {selectedItem?.name}
                        </Title>
                      )}
                      {selectedItem.status && !loading ? (
                        <Badge
                          variant="light"
                          color={getStatusColor(selectedItem.status)}
                          style={{
                            flexShrink: 0,
                          }}
                        >
                          {selectedItem.status}
                        </Badge>
                      ) : null}
                      {selectedItem.distributionDate &&
                      selectedItem.distributionDate.length ? (
                        <Group gap={"xs"}>
                          {/* <Tooltip color="dark" label="Show Master Records">
                      <ActionIcon variant="default">
                        <IconDatabase
                          size={AppConstants.ICON_SIZE}
                          stroke={AppConstants.ICON_STROKE_WIDTH}
                        />
                      </ActionIcon>
                    </Tooltip> */}
                          <Tooltip
                            color="dark"
                            label="Navigate to Style Distribution"
                          >
                            <ActionIcon variant="default">
                              <IconArrowUpRight
                                size={AppConstants.ICON_SIZE}
                                stroke={AppConstants.ICON_STROKE_WIDTH}
                              />
                            </ActionIcon>
                          </Tooltip>
                        </Group>
                      ) : null}
                    </Group>
                  </Link>

                  <Box>
                    <Group my="md">
                      <MetaLabel>Style Number</MetaLabel>
                      <div>
                        <Text size="sm">
                          <Anchor
                            component={Link}
                            to={`/distributions/${selectedItem.styleNumber}`}
                            onClick={() => closeAllModals()}
                          >
                            {selectedItem?.styleNumber}
                          </Anchor>
                        </Text>
                      </div>
                    </Group>
                    <Group my="md">
                      <MetaLabel>Department</MetaLabel>
                      <div>
                        <Text size="sm">{selectedItem.dept}</Text>
                      </div>
                    </Group>

                    <Group my="md">
                      <MetaLabel>{getClientLabel(user.clientCode, 'otbDate')}</MetaLabel>
                      <div>
                        <Text
                          size="sm"
                          c={
                            selectedItem.otbDate && selectedItem.otbDate.length
                              ? "inherit"
                              : "dimmed"
                          }
                        >
                          {selectedItem.otbDate &&
                          selectedItem.otbDate.length ? (
                            <DateDisplay
                              value={selectedItem.otbDate}
                              parse="YYYY-MM-DD-hh-mm-ss"
                              format="DD/MM/YYYY"
                              trim
                            />
                          ) : (
                            "-"
                          )}
                        </Text>
                      </div>
                    </Group>

                    <Group my="md">
                      <MetaLabel>Shoot Date</MetaLabel>
                      <div>
                        <Text
                          size="sm"
                          c={
                            selectedItem.shootDate &&
                            selectedItem.shootDate.length
                              ? "inherit"
                              : "dimmed"
                          }
                        >
                          {selectedItem.shootDate &&
                          selectedItem.shootDate.length
                            ? selectedItem.shootDate
                            : "-"}
                        </Text>
                      </div>
                    </Group>

                    <Group my="md">
                      <MetaLabel>Distribution Date</MetaLabel>
                      <div>
                        <Text
                          size="sm"
                          c={
                            selectedItem.distributionDate &&
                            selectedItem.distributionDate.length
                              ? "inherit"
                              : "dimmed"
                          }
                        >
                          {selectedItem.distributionDate &&
                          selectedItem.distributionDate.length ? (
                            <Moment
                              date={selectedItem.distributionDate}
                              parse="YYYY-MM-DD-hh-mm-ss"
                              format="DD/MM/YYYY"
                              trim
                            />
                          ) : (
                            "-"
                          )}
                        </Text>
                      </div>
                    </Group>
                  </Box>
                </>
              ) : (
                <>
                  {!loading ? (
                    <Alert color="orange" title="Record Not Found" mt={5}>
                      <Text size="sm" opacity={0.7}>
                        No Distribution events for this keycode
                      </Text>
                    </Alert>
                  ) : null}
                  
                </>
              )}
              {/* 
<>
                {!loading && globalSearch?.style && (!globalSearch?.style.assets || globalSearch?.style.assets.length === 0) ? (
                <Alert color="orange" title="Record Not Found">
                  <Text size="sm" opacity={0.7}>No OnSet record exists for this Style</Text>
                </Alert>
                ) : null}
                </> */}

              <StyleInfoSections selectedItem={selectedItem} user={user} loading={loading} storageKey="op-master-drawer" />
              {/* <Divider my="md" /> */}

              {selectedItem?.assets && selectedItem?.assets.length ? (
                <Divider />
              ) : null}

              {selectedItem?.assets && selectedItem?.assets.length ? (
                <Box mt={"md"}>
                  <Group mb="lg">
                    <Title className="main-content-heading" order={6}>
                      Assets
                    </Title>
                    {selectedItem?.assets?.length && !loading ? (
                      <PrimaryBadge>
                        {selectedItem?.assets?.length}
                      </PrimaryBadge>
                    ) : null}
                  </Group>
                  <Group
                    gap={"md"}
                    wrap="wrap"
                    justify="start"
                    style={{ display: "flex" }}
                  >
                    {loading ? (
                      // Show skeletons when loading
                      [...Array(3)].map((_, idx) => (
                        <Skeleton key={`skeleton-${idx}`} height={80} width={80} radius="sm" />
                      ))
                    ) : (
                      // Show actual assets when not loading
                      selectedItem?.assets?.map((val, idx) => {
                        // var imageURL = val && val.preview ? val.preview : "";
                        return (
                          <div
                            key={idx}
                            style={{
                              height: "100%",
                              width: 80,
                              position: "relative",
                              borderRadius: 8,
                              overflow: "hidden",
                            }}
                          >
                            {val ? (
                              <ImagePreview
                                file={{ url: val?.thumb }}
                                onClick={() => zoomImage(val)}
                                height={100}
                                width={"auto"}
                              />
                            ) : (
                              //   <ImagePreview
                              //     shot={{ ...val, ...selectedItem }}
                              //     size={100}
                              //     src={imageURL}
                              //     tags={val.tags}
                              //     fit="contain"
                              //     showMetaInfo={false}
                              //   />
                              <div></div>
                            )}
                          </div>
                        );
                      })
                    )}
                  </Group>

                  {!selectedItem ||
                  (selectedItem && selectedItem.assets?.length === 0) ? (
                    <EmptyState
                      caption="There are no assets"
                      style={{ height: 200 }}
                    />
                  ) : null}
                  {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
                </Box>
              ) : null}
            </Card>
          ) : (
            <Center sx={{ height: "100%", minHeight: 400 }}>
              <div style={{ textAlign: "center" }}>
                {/* <IconCamera size={48} stroke={1} />
                <Title color={"dimmed"} order={3}>
                  Select an Image
                </Title> */}
              </div>
            </Center>
          )}
        </ScrollArea>
      </div>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={false}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        withinPortal={true}
        zIndex={1000}
        onClose={() =>
          dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: false }))
        }
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
              showSettings={false}
              resoloveImage={false}
              image={selectedAsset}
              src={selectedAsset?.preview}
              onImageEvent={() => logger.log("On image event")}
              onCaptureChange={() => {}}
            /> */}

        <StyleAssetViewer
          user={user}
          style={selectedItem}
          index={selectedItem?.assets?.findIndex(
            (val) => val.assignedSequence === selectedAsset?.assignedSequence
          )}
          onClose={() =>
            dispatch(
              setGlobalSearch({ ...globalSearch, imageModalOpen: false })
            )
          }
        />
      </Modal>
    </Box>
  );
};

export default MasterDrawer;
const DatabaseImage = () => {
  const { theme } = useStyles();
  const strokeColor =
    theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.brand[1];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0" />
      <path d="M4 6v6a8 3 0 0 0 16 0v-6" />
      <path d="M4 12v6a8 3 0 0 0 16 0v-6" />
    </svg>
  );
};

const BarcodeImage = () => {
  const { theme } = useStyles();
  const strokeColor =
    theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.brand[1];

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 1.5,
      }}
    >
      <path
        d="M891,293.385C891,273.304 874.696,257 854.615,257L169.385,257C149.304,257 133,273.304 133,293.385L133,730.615C133,750.696 149.304,767 169.385,767L854.615,767C874.696,767 891,750.696 891,730.615L891,293.385Z"
        style={{ fill: "none", stroke: strokeColor, strokeWidth: "15px" }}
      />
      <path
        d="M219.945,321.22L219.945,701.954"
        style={{
          fill: "none",
          stroke: strokeColor,
          strokeWidth: "38px",
          strokeLinecap: "butt",
        }}
      />
      <g transform="matrix(1,0,0,1,588.073,0)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "38px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,52.0052,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,84.0104,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,126.016,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,168.021,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,210.026,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,252.031,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "32.91px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,294.036,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,315.039,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,336.042,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,357.044,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,378.047,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,432.179,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,399.049,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,462.057,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,504.062,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,536.068,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(2.17273,0,0,2.17273,-323.186,-775.261)">
        <text
          x="268.822px"
          y="664.032px"
          style={{
            fontFamily: "'AmsiPro-Bold', sans-serif",
            fontSize: "12px",
            fill: strokeColor,
          }}
        >
          NO SC
          <tspan x="303.958px " y="664.032px ">
            A
          </tspan>
          N A
          <tspan x="330.97px 337.654px " y="664.032px 664.032px ">
            VA
          </tspan>
          ILABLE
        </text>
      </g>
    </svg>
  );
};
